import type { MetricTrend } from "@/components/metrics/metric-card";

export function computeTrend(current: number, previous: number): MetricTrend {
  const raw = current - previous;
  if (raw === 0) return { delta: 0, direction: "flat" };
  return { delta: Math.abs(raw), direction: raw > 0 ? "up" : "down" };
}
